// extracted by mini-css-extract-plugin
export default {"resourceLink":"ResourceItem_resourceLink__5Z5T4","resourceIcon":"ResourceItem_resourceIcon__U5FmI"};